import './footer.scss';
import facebook from '../../assets/images/icons/facebook.svg';
import instagram from '../../assets/images/icons/instagram.svg';
import twitter from '../../assets/images/icons/twitter.svg';
import telegram from '../../assets/images/icons/telegram.svg';
import {useTranslation} from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer id="footer" className="footer">
            <div className="main-container">
                <div className="footer-row">
                    {/*<div className="footer-social-col">
                        <div className="footer-social-title">{ t('footer.followUs') }</div>
                        <ul className="footer-social-list">
                            <li><a rel="noreferrer" href="https://www.facebook.com/accemedin/" target="_blank"><img
                                src={facebook} alt=""/></a></li>
                            <li><a rel="noreferrer" href="https://www.instagram.com/accemedin_/" target="_blank"><img
                                src={instagram} alt=""/></a></li>
                            <li><a rel="noreferrer" href="https://twitter.com/Accemedin_com" target="_blank"><img
                                src={twitter} alt=""/></a></li>
                            <li><a rel="noreferrer" href="https://t.me/accemedin" target="_blank"><img
                                src={telegram} alt=""/></a></li>
                        </ul>
                    </div>*/}
                    <div className="footer-info-col">
                        {/*<nav className="secondary-menu">
                            <ul>
                                <li>
                                    <a href="/about">{t('footer.about')}</a>
                                </li>
                                <li>
                                    <a href="mailto:support@accemedin.com">support@accemedin.com</a>
                                </li>
                                <li>
                                    <a href="/static/documents/document.pdf" target="_blank">
                                        { t('footer.termsAndConditions') }
                                    </a>
                                </li>
                                <li>
                                    <a href="/static/documents/privacy_policy.pdf" target="_blank">
                                        { t('footer.privacyPolicy') }
                                    </a>
                                </li>
                                <li>
                                    <a href="/paymentPolicy">
                                        { t('footer.paymentPolicy') }
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <div className="footer-address">
                            { t('footer.address.firstLine') }
                            <span className="break-line"/>
                            <span dangerouslySetInnerHTML={{__html: t('footer.address.secondLine')}}/>
                        </div>*/}
                        <div className="footer-copyright">
                            <span dangerouslySetInnerHTML={{__html: t('footer.copyright.firstLine')}}/>
                            <span className="break-line"/>
                            { t('footer.copyright.secondLine') }
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
